import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DzIconModule } from '@blk/daisy/core/icon';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { StaticBannerComponent } from './static-banner.component';

@NgModule({
	declarations: [StaticBannerComponent],
	imports: [CommonModule, DzIconModule.withIcons(faTimes)],
	exports: [StaticBannerComponent]
})
export class StaticBannerModule {}
